<div class="flex flex-auto">
    <p-autoComplete #partySearchComponent appendTo="body" [(ngModel)]="selectedParty" [suggestions]="partySuggestions" 
                        (completeMethod)="partySearch($event)" [placeholder]="placeholder" optionLabel="displayName"
                        class="m-2 flex flex-auto" styleClass="flex flex-auto" inputStyleClass="flex flex-auto" (onSelect)="selectParty($event)">
        <ng-template let-party pTemplate="item">
            <div class="flex align-items-center gap-2" >
                <div class="flex" >{{ party.firstName }} {{ party.lastName }} {{party.dateOfBirth | date : 'shortDate'}} </div>
            </div>
        </ng-template>
    </p-autoComplete>
</div>
